"use client";

import PageHeader from "../shared/PageHeader";

const CustomPage = ({ pageData }) => {
  return (
    <div>
      <PageHeader title={pageData?.page?.name} />
      <div className="section_space_py">
        <div className="custom-container mx-auto">
          <div className="border border-user-input-border rounded-[18px] p-5 sm:p-7.5">
            <div
              className="inner-html-box"
              dangerouslySetInnerHTML={{
                __html: pageData?.page?.data?.content,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPage;
